import {Component, OnInit} from "@angular/core";
import {ViewController, Events, NavParams} from "ionic-angular";
import {SpecialityService} from "../../../pages/shared/specialities/speciality.service";

@Component({
  templateUrl: 'specialities-select-modal.component.html',
})
export class SpecialitiesSelectModal implements OnInit {
  specialities: any[];

  constructor(private viewCtrl: ViewController,
              private events: Events,
              private specialityService: SpecialityService,
              private navParams: NavParams
  ) {
  }
  ngOnInit(){
    this.getSpecialities();
  }

  dismiss() {
    return this.viewCtrl.dismiss();
  }

  selectSpeciality(speciality){
    let event = this.navParams.get('event') || 'speciality:selected';
    this.events.publish(event, speciality);
    this.dismiss();
  }

  getSpecialities(){
    this.specialityService.getSpecialities()
      .subscribe(specialities => {
        this.specialities = specialities;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/specialities-select-modal/specialities-select-modal.component.ts